export default __webpack_public_path__ + "static/SR China - Ingredient & Label - Caramel Colors - Statement-e933ae7cc6dc34e56117b44ba475af6b.pdf";